import React, {useContext, useEffect, useState , useRef, RefObject} from 'react';
import CartEventsContext from "../../common/contexts/CartEventsContext";
import {QuantityPicker, CartButton} from '@zooplus/ui-components';
import {CheckCircle} from "@zooplus/icons";
import LocResourcesContext from "../../common/contexts/LocResourcesContext";

const CSS_PREFIX = "loy-add-to-cart";

interface AddToCartComponentProps {
    articleId: number;
    articleShopId: number;
    articleSelection: number[];
    max: number;
    quantityInCart: number;
}

const AddToCartComponent = ({
    articleId,
    articleShopId,
    articleSelection,
    max,
    quantityInCart}: AddToCartComponentProps): JSX.Element => {
    const buttonRef: RefObject<HTMLButtonElement> = useRef<HTMLButtonElement>(null);
    const [selectedQuantity, setSelectedQuantity] = useState<number>(quantityInCart);
    const [adding, setAdding] = useState<boolean>(false);
    const { onAddToCart } = useContext(CartEventsContext);
    const { onFormatLocale } = useContext(LocResourcesContext);

    useEffect(() => {
        setSelectedQuantity(quantityInCart);
        setAdding(false);
    }, [quantityInCart]);

    const maxValue = () => {
        return max ? max : 9;
    }

    const defaultSelections = () => {
        let result: number[] = [];
        for (let i = 0; i <= maxValue(); i++) {
            result.push(i);
        }
        return result;
    }

    const handleAmountChange = (quantity: number) => {
        const newValue = Math.max(0, Math.min(quantity, maxValue()));
        setSelectedQuantity(newValue);
    }

    const renderSelectComponent = () => {
        const selectableArticle = (articleSelection !== undefined) && (articleSelection.length > 0);

        const selections = (selectableArticle ? articleSelection : defaultSelections())
            .filter((step: number) => step <= maxValue());
        return (
            <QuantityPicker
                onValueChange={(quantity) => handleAmountChange(quantity)}
                options={selections}
                selectProps={{
                    id: `count_${articleShopId}`,
                    className: `${CSS_PREFIX}_select-component--quantity-picker`,
                }}
                value={selectedQuantity}
                size="small"
                selectLabel ={`${onFormatLocale?.('loy.rewards.shop.selectproductstbutton')}`}
                data-zta={`amount_${articleShopId}`}
                style={{width: '6rem'}}
            />
        )
    }

    const addToCart = () => {
        if (!adding) {
            let quantityToAdd = (selectedQuantity === 0 && quantityInCart === 0) ? 1 : selectedQuantity;
            setAdding(true);
            const node = buttonRef.current;
            onAddToCart?.(articleId, quantityToAdd, node);
        }
    }

    const renderCartFeedBack = () => {
        return <div className={`${CSS_PREFIX}_feed-back-btn`}><CheckCircle /></div>
    }

    return (
        <div className={`${CSS_PREFIX}`}>
            <div className={`${CSS_PREFIX}_section ${CSS_PREFIX}_select-component`}>
                {renderSelectComponent()}
            </div>
            <div className={`${CSS_PREFIX}_section addtocart`}>
                {adding
                    ? <CartButton iconOnly isLoading loadingIconType="paw" size="small"/>
                    : <CartButton
                        iconOnly
                        ref={buttonRef}
                        size="small"
                        data-zta={`addtocartbtn_${articleShopId}`}
                        aria-label={`${onFormatLocale?.('loy.rewards.shop.addtocartbutton')}`}
                        onClick={() => addToCart()}/>
                }
                {quantityInCart > 0 && renderCartFeedBack()}
            </div>
        </div>
    )
}

export default AddToCartComponent;
